<template>
  <div class="card">
    <div class="card-header bg-light">
      <div class="card-header-title text-muted">
        Thông tin cá nhân
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-4 col-12">
          <div class="form-group">
            <label class="form-label required">
              Họ và tên
              <span class="invalid-feedback d-block" v-if="'contact.name' in violations">
                <span class="d-block">
                  <span class="form-error-icon badge badge-danger text-uppercase mr-1">Lỗi</span>
                  <span class="form-error-message">{{ violations['contact.name'] }}</span>
                </span>
              </span>
            </label>
            <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid' : 'contact.name' in violations }"
                v-model="form.contact.name"
            />
          </div>
        </div>
        <div class="col-sm-4 col-12">
          <div class="form-group">
            <label class="form-label required">
              Số điện thoại
              <span class="invalid-feedback d-block" v-if="'contact.phone' in violations">
                <span class="d-block">
                  <span class="form-error-icon badge badge-danger text-uppercase mr-1">Lỗi</span>
                  <span class="form-error-message">{{ violations['contact.phone'] }}</span>
                </span>
              </span>
            </label>
            <input
                type="tel"
                class="form-control"
                :class="{ 'is-invalid' : 'contact.phone' in violations }"
                v-model="form.contact.phone"
            />
          </div>
        </div>
        <div class="col-sm-4 col-12">
          <div class="form-group">
            <label class="form-label">
              Email
              <span class="invalid-feedback d-block" v-if="'contact.email' in violations">
                <span class="d-block">
                  <span class="form-error-icon badge badge-danger text-uppercase mr-1">Lỗi</span>
                  <span class="form-error-message">{{ violations['contact.email'] }}</span>
                </span>
              </span>
            </label>
            <input
                type="email"
                class="form-control"
                :class="{ 'is-invalid' : 'contact.email' in violations }"
                v-model="form.contact.email"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  contact: {
    type: Object,
    required: true,
    default: () => ({
      name: null,
      phone: null,
      email: null
    })
  },
  violations: {
    type: Array,
    required: true,
    default: []
  }
})

const emit = defineEmits(['update:contact'])

const form = ref({
  contact: props.contact
})

watch(() => props.contact, (value) => {
  form.value.contact = value
}, { deep: true })

watch(() => form.value.contact, (value) => {
  emit('update:contact', value)
}, { deep: true })
</script>

<style scoped>
.required:before {
  content: "* ";
  color: #dc3545;
}
</style>

